import { connect } from 'react-redux'
import { intl } from '../../../../i18n'
import { AllState } from '../../../../store'
import ReloadButton from '../../../components/buttons/ReloadButton'
import SubmitButton from '../../../components/buttons/SubmitButton'
import { ToolbarFilterGroupProps } from '../../../components/buttons/ToolbarFilterButtonGroup'
import CancelConfirmDialog from '../../../components/dialogs/CancelConfirmDialog'
import { useDialogState } from '../../../components/dialogs/useDialogState'
import MultipleToggleGroup from '../../../components/editors/toggle/MultipleToggleGroup'
import PageHeader, {
  HeaderContent,
  HeaderDivider,
  HeaderGroup,
  IconGroup,
} from '../../../components/headers/HeaderBar/PageHeader'
import SettingSpeedDial, {
  SettingSpeedDialProps,
} from '../../../components/headers/HeaderBar/SettingSpeedDial'
import {
  ToolbarToggleGroup,
  ToolbarToggleValue,
} from '../../../components/toolbars/Toolbar/ToolbarToggle'
import { QuickFilterKeys } from '../../ProjectPlan/projectPlanOptions'

interface OwnProps {
  toolbar: ToolbarToggleValue | undefined
  onChangeToolbar: (value: ToolbarToggleValue | undefined) => void
  isNotice: boolean
  onSubmit: () => void
  submitDisabled: boolean
  isLoading: boolean
  onCancel: () => void
  onChange: (values: string[]) => void
  quickFilter?: string[]
}

interface StateProps {
  notEdited: boolean
}

type Props = OwnProps &
  StateProps &
  SettingSpeedDialProps &
  ToolbarFilterGroupProps

const MyTasksHeader = ({
  onSubmit,
  submitDisabled,
  isLoading,
  notEdited,
  onCancel,
  onClickExport,
  rowHeight,
  onClickChangeRowHeight,
  onChangeToolbar,
  toolbar,
  isNotice,
  onChange,
  quickFilter: values,
}: Props) => {
  const [showCancelDialog, openCancelDialog, closeCancelDialog] =
    useDialogState()

  return (
    <PageHeader>
      <HeaderContent>
        <HeaderGroup>
          <SubmitButton
            onClick={onSubmit}
            disabled={submitDisabled || isLoading || notEdited}
            notEdited={notEdited}
          />
          <ReloadButton onClick={openCancelDialog} disabled={isLoading} />
          <CancelConfirmDialog
            open={showCancelDialog}
            onConfirm={() => {
              closeCancelDialog()
              onCancel()
            }}
            onClose={closeCancelDialog}
          />
        </HeaderGroup>
        <HeaderDivider />
        <HeaderGroup>
          <IconGroup>
            <SettingSpeedDial
              onClickExport={onClickExport}
              rowHeight={rowHeight}
              onClickChangeRowHeight={onClickChangeRowHeight}
            />
          </IconGroup>
        </HeaderGroup>
        <HeaderDivider />
        <HeaderGroup>
          <MultipleToggleGroup
            values={values}
            options={[
              {
                value: QuickFilterKeys.ACCOUNTABLE,
                label: intl.formatMessage({
                  id: 'bulksheet.toolbar.quickFilter.label.accountable',
                }),
              },
              {
                value: QuickFilterKeys.RESPONSIBLE_OR_ASSIGNEE,
                label: intl.formatMessage({
                  id: 'bulksheet.toolbar.quickFilter.label.responsibleOrAssignee',
                }),
              },
              {
                value: QuickFilterKeys.DELAY,
                label: intl.formatMessage({
                  id: 'bulksheet.toolbar.quickFilter.label.delay',
                }),
              },
              {
                value: QuickFilterKeys.COMMENT,
                label: intl.formatMessage({
                  id: 'bulksheet.toolbar.quickFilter.label.comment',
                }),
              },
            ]}
            onChange={onChange}
          />
        </HeaderGroup>
        <ToolbarToggleGroup
          toggleItems={[ToolbarToggleValue.DISPLAY, ToolbarToggleValue.REPORT]}
          value={toolbar}
          onChange={onChangeToolbar}
          noticeItem={ToolbarToggleValue.DISPLAY}
          isNotice={isNotice}
        />
      </HeaderContent>
    </PageHeader>
  )
}

const mapStateToProps = (state: AllState) => ({
  notEdited: !state.hasRequiredSaveData.hasRequiredSaveData,
})

export default connect(mapStateToProps)(MyTasksHeader)
